<script>
import FeaturePlaceholder from './FeaturePlaceholder.vue';
export default {
  components: { FeaturePlaceholder },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div class="flex flex-col items-center justify-center h-full p-8">
    <!-- Modern icon với glassmorphism -->
    <div class="w-24 h-24 mb-6 bg-white bg-opacity-40 dark:bg-slate-800 dark:bg-opacity-40 backdrop-blur-sm rounded-2xl shadow-lg flex items-center justify-center border border-white border-opacity-20 dark:border-slate-600 dark:border-opacity-30">
      <svg class="w-12 h-12 text-slate-400 dark:text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
    </div>
    
    <!-- Message với typography đẹp -->
    <div class="text-center max-w-md">
      <h3 class="text-lg font-semibold text-slate-700 dark:text-slate-200 mb-2">
        {{ message }}
      </h3>
      <p class="text-sm text-slate-500 dark:text-slate-400 leading-relaxed">
        {{ $t('CONVERSATION.EMPTY_STATE_SUBTITLE') }}
      </p>
    </div>
    
    <!-- Keyboard shortcuts hint -->
    <div class="mt-8 p-4 bg-white bg-opacity-30 dark:bg-slate-800 dark:bg-opacity-30 backdrop-blur-sm rounded-xl border border-white border-opacity-20 dark:border-slate-600 dark:border-opacity-30">
      <FeaturePlaceholder />
    </div>
  </div>
</template>
